import React from "react";

export function Page({ title, subtitle, actions, children }) {
  return (
    <div className="max-w-7xl mx-auto pt-2 pb-10">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8 mf-fade-in">
        <div>
          <h1 className="font-serif text-3xl sm:text-4xl tracking-tight" style={{ color: "var(--mf-text)" }}>{title}</h1>
          {subtitle && <p className="text-sm mt-1" style={{ color: "var(--mf-text-muted)" }}>{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export function Card({ children, className = "", delay = 0, testid }) {
  return (
    <div className={`mf-card p-6 mf-fade-in ${className}`} style={{ animationDelay: `${delay}s` }} data-testid={testid}>
      {children}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, accent, delay = 0, testid }) {
  return (
    <div className="mf-card p-5 mf-fade-in" style={{ animationDelay: `${delay}s` }} data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-wider mb-1" style={{ color: "var(--mf-text-muted)" }}>{label}</div>
          <div className="font-serif text-3xl" style={{ color: "var(--mf-text)" }}>{value}</div>
        </div>
        {Icon && (
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${accent || "var(--mf-primary)"}15`, color: accent || "var(--mf-primary)" }}>
            <Icon className="w-5 h-5" strokeWidth={1.5} />
          </div>
        )}
      </div>
    </div>
  );
}

export function Pill({ children, variant = "default" }) {
  const map = {
    default: { bg: "var(--mf-muted)", fg: "var(--mf-text)" },
    primary: { bg: "rgba(26,107,114,0.12)", fg: "var(--mf-primary)" },
    success: { bg: "rgba(123,174,127,0.18)", fg: "#4a7a4e" },
    warn: { bg: "rgba(201,168,76,0.18)", fg: "#8a6f20" },
    danger: { bg: "rgba(220,38,38,0.12)", fg: "#b91c1c" },
  };
  const s = map[variant] || map.default;
  return (
    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium" style={{ background: s.bg, color: s.fg }}>
      {children}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="mf-card p-12 text-center mf-fade-in">
      {Icon && (
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ background: "var(--mf-muted)" }}>
          <Icon className="w-7 h-7" style={{ color: "var(--mf-primary)" }} strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-serif text-2xl mb-2" style={{ color: "var(--mf-text)" }}>{title}</h3>
      {description && <p className="text-sm mb-5 max-w-md mx-auto" style={{ color: "var(--mf-text-muted)" }}>{description}</p>}
      {action}
    </div>
  );
}

export function PrimaryButton({ children, onClick, type = "button", disabled, testid, className = "" }) {
  return (
    <button type={type} onClick={onClick} disabled={disabled} className={`mf-btn-primary disabled:opacity-60 disabled:cursor-not-allowed ${className}`} data-testid={testid}>
      {children}
    </button>
  );
}

export function GhostButton({ children, onClick, testid, className = "" }) {
  return (
    <button onClick={onClick} className={`px-4 py-2 rounded-full text-sm font-medium transition-all hover:bg-black/5 ${className}`} style={{ color: "var(--mf-primary)" }} data-testid={testid}>
      {children}
    </button>
  );
}
